import { render, staticRenderFns } from "./GroupNode.vue?vue&type=template&id=b1be57e2&scoped=true&"
import script from "./GroupNode.vue?vue&type=script&setup=true&lang=js&"
export * from "./GroupNode.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GroupNode.vue?vue&type=style&index=0&id=b1be57e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1be57e2",
  null
  
)

export default component.exports